// API client for topastrologerinindia.com
// Replaces the previous localStorage mock layer.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "tai_admin_token_v2";
const EMAIL_KEY = "tai_admin_email_v2";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || null;
}
export function getEmail() {
  return localStorage.getItem(EMAIL_KEY) || null;
}
export function setSession(token, email) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(EMAIL_KEY, email || "");
  } else {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(EMAIL_KEY);
  }
}

async function request(path, { method = "GET", body, auth = false } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth) {
    const t = getToken();
    if (t) headers["Authorization"] = `Bearer ${t}`;
  }
  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let msg = `Request failed: ${res.status}`;
    try {
      const data = await res.json();
      msg = data.detail || msg;
    } catch (e) {}
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
}

// --- Auth ---
export async function apiLogin(email, password) {
  const data = await request("/admin/login", {
    method: "POST",
    body: { email, password },
  });
  setSession(data.access_token, data.email);
  return data;
}

export async function apiMe() {
  return request("/admin/me", { auth: true });
}

export function apiLogout() {
  setSession(null, null);
}

// --- Astrologers ---
export async function apiGetAstrologers() {
  return request("/astrologers");
}
export async function apiUpdateAstrologer(id, patch) {
  return request(`/astrologers/${id}`, { method: "PUT", body: patch, auth: true });
}
export async function apiCreateAstrologer(payload = {}) {
  return request("/astrologers", { method: "POST", body: payload, auth: true });
}
export async function apiDeleteAstrologer(id) {
  return request(`/astrologers/${id}`, { method: "DELETE", auth: true });
}
export async function apiMoveAstrologer(id, direction) {
  return request(`/astrologers/${id}/move`, {
    method: "POST",
    body: { direction },
    auth: true,
  });
}
export async function apiResetAll() {
  return request("/astrologers/reset", { method: "POST", auth: true });
}

// --- Site meta ---
export async function apiGetSiteMeta() {
  return request("/site-meta");
}
export async function apiUpdateSiteMeta(meta) {
  return request("/site-meta", { method: "PUT", body: meta, auth: true });
}
